export interface Category {
  name: string;
  slug: string;
  url: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    name: 'Hoodies / Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
  },
  {
    name: 'Pants / Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
  },
  {
    name: 'Underwear / Underpants',
    slug: 'underwear',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
  },
  {
    name: 'Other Stuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
  },
];